import { render, staticRenderFns } from "./DialogueForm.vue?vue&type=template&id=c8fd6136&scoped=true"
import script from "./DialogueForm.vue?vue&type=script&lang=js"
export * from "./DialogueForm.vue?vue&type=script&lang=js"
import style0 from "./DialogueForm.vue?vue&type=style&index=0&id=c8fd6136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fd6136",
  null
  
)

export default component.exports